import { createFileRoute } from '@tanstack/react-router';
import { MaterialsTab } from '@/app/(client)/my-styles/-components/MaterialsTab';
import { isEntityKindPath } from '@/app/(client)/my-styles/-hooks/useEntityDetail';
import { materialHeadersQueryOptions } from '@/app/(client)/my-styles/-hooks/useMaterialHeaders';
import { rawMaterialsQueryOptions } from '@/hooks/useRawMaterials';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/materials',
)({
  loader: ({ params }) => {
    if (!isEntityKindPath(params.kind)) return;
    return Promise.all([
      queryClient.ensureQueryData(materialHeadersQueryOptions(params.id)),
      queryClient.ensureQueryData(rawMaterialsQueryOptions()),
    ]);
  },
  component: MaterialsRoute,
});

function MaterialsRoute() {
  const { kind, id } = Route.useParams();
  if (!isEntityKindPath(kind)) return null;
  return <MaterialsTab kind={kind} id={id} />;
}
